import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [ 'overlayTemplate' ]

	connect() {
		this.activeOverlays = []
	}

	disconnect() {
		this.removeActiveOverlays()
	}

	addOverlay(event) {
		this.removeActiveOverlays()

		const clonedOverlay = this.overlayTemplateTarget.content.cloneNode(true)
		event.currentTarget.style.position = 'relative'
		event.currentTarget.prepend(clonedOverlay)
		this.activeOverlays.push(event.currentTarget.firstChild)
	}

	removeOverlay(_event) {
		this.removeActiveOverlays()
	}

	removeActiveOverlays() {
		if (this.activeOverlays.length == 0) { return }
		this.activeOverlays.forEach((overlay) => overlay.remove())
		this.activeOverlays = []
	}
}
